export default "__VITE_ASSET__vYnT5vRe__"